import { Stack } from "@mui/material";
import { CLIPBOARD_SCORE } from "@src/appV2/ClipboardScore/constants";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";
import {
  Callout,
  CardWithIntent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@src/appV2/redesign/system/ui-components";

interface CreateSentHomeRequestInfoProps {
  workplaceName: string;
  shouldShowSentHomeRequestLineItems: boolean;
  isSentHomeRequestPayable: boolean;
  payableAmountInDollars: number;
}

export function CreateSentHomeRequestInfo(props: CreateSentHomeRequestInfoProps) {
  const {
    workplaceName,
    shouldShowSentHomeRequestLineItems,
    isSentHomeRequestPayable,
    payableAmountInDollars,
  } = props;

  return (
    <Stack spacing={3} sx={{ paddingX: 5, paddingBottom: 8 }}>
      <List sx={{ "& .MuiListItem-root": { py: 3 } }}>
        {shouldShowSentHomeRequestLineItems &&
          (isSentHomeRequestPayable ? (
            <ListItem>
              <ListItemIcon iconType="dot" />
              <ListItemText>
                <Text>
                  You&apos;ll receive <b>{formatDollarsAsUsd(payableAmountInDollars)}</b> for your
                  time today once your request has been approved. Payment may take up to 1 week to
                  process.
                </Text>
              </ListItemText>
            </ListItem>
          ) : (
            <>
              <ListItem>
                <ListItemIcon iconType="dot" />
                <ListItemText>
                  <Text variant="body1">{workplaceName} does not offer sent home pay</Text>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon iconType="dot" />
                <ListItemText>
                  <Text>
                    If this request is approved, you will not receive any compensation but you will
                    avoid {CLIPBOARD_SCORE} penalties
                  </Text>
                </ListItemText>
              </ListItem>
            </>
          ))}
        <ListItem>
          <ListItemIcon iconType="dot" />
          <ListItemText>
            <Text variant="body1">A timesheet is not required for this request</Text>
          </ListItemText>
        </ListItem>
      </List>

      <CardWithIntent intent="warning">
        <Stack spacing={4} sx={{ paddingX: 6, paddingTop: 4, paddingBottom: 6 }}>
          <Callout
            iconType="triangle-exclamation"
            title=""
            sx={(theme) => ({
              backgroundColor: theme.palette.shift?.urgent.background,
              color: theme.palette.shift?.urgent.text,
              width: 48,
              paddingLeft: 5,
            })}
          />
          <Text sx={{ color: (theme) => theme.palette.text.secondary }}>
            If {workplaceName} rejects your sent home request, you will be considered a No Show and
            become restricted. Ask staff to verify your request before leaving. For illness or
            safety incidents, contact Clipboard Health support instead.
          </Text>
        </Stack>
      </CardWithIntent>
    </Stack>
  );
}
